import { render, staticRenderFns } from "./MasiveUpdateHistory.vue?vue&type=template&id=53b91fb7&scoped=true&"
import script from "./MasiveUpdateHistory.vue?vue&type=script&lang=js&"
export * from "./MasiveUpdateHistory.vue?vue&type=script&lang=js&"
import style0 from "./MasiveUpdateHistory.vue?vue&type=style&index=0&id=53b91fb7&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b91fb7",
  null
  
)

export default component.exports